import { render } from "./SponsorCreate.vue?vue&type=template&id=67822b4a"
import script from "./SponsorCreate.vue?vue&type=script&lang=js"
export * from "./SponsorCreate.vue?vue&type=script&lang=js"
script.render = render

export default script